import { gql } from '@apollo/client';
export const SPEND_STATS = gql `
  query SPEND_STATS($spec: DashboardSpec!) {
    spendStats(spec: $spec) {
      amountSpent
      amountPending
    }
  }
`;
export const UTILIZATION_STATS = gql `
  query UTILIZATION_STATS($spec: DashboardSpec!) {
    utilizationStats(spec: $spec) {
      total
      signedUp
      utilized
    }
  }
`;
export const MONTHLY_ACTIVITY = gql `
  query MONTHLY_ACTIVITY($spec: DashboardSpec!) {
    monthlyActivity(spec: $spec) {
      month
      amountApproved
      programCount
      paymentRequestCount
      pendingCount
      approvedCount
      rejectedCount
    }
  }
`;
